<template>
    <div class="h-full flex">
        <Toast></Toast>

        <!-- Main Area -->
        <div class="flex-1 flex flex-col overflow-hidden">
            <!-- Header -->

            <header class="w-full">
                <div
                    class="relative z-10 flex-shrink-0 h-16 border-b border-gray-200 shadow-sm flex"
                    :style="{ backgroundColor: $page.props.branding?.navbar_color || '#2f3441', color: $page.props.branding?.navbar_text_color || '#ffffff' }"
                >
                    <div class="relative flex-1 flex justify-between px-4 sm:px-6">
                        <!-- Header Content -->
                        <div class="flex-1 flex items-center">
                            <Link href="/">
                                <img
                                    v-if="$page.props.branding?.logo_url"
                                    class="h-10 w-auto"
                                    :src="$page.props.branding.logo_url"
                                    alt="Agency Logo"
                                />
                                <img
                                    v-else
                                    class="h-10 w-auto"
                                    src="../../image/immivo.svg"
                                    alt="immivo"
                                />
                            </Link>
                        </div>
                        
                        <!-- Agency Name (Center) -->
                        <div v-if="$page.props.isSuperAdmin && $page.props.user.currentAgencyName" class="absolute inset-0 flex items-center justify-center pointer-events-none">
                            <span class="text-xl font-bold uppercase tracking-wider pointer-events-auto">
                                {{ $page.props.user.currentAgencyName }}
                            </span>
                        </div>

                        <!-- Top Right Menu -->
                        <div
                            class="ml-2 pl-4 flex items-center space-x-4 sm:ml-6 sm:space-x-6"
                        >
                            <!--                             <button type="button"
                                    class="flex p-1 rounded-full items-center justify-center text-white hover:bg-minplan-lightgrey focus:outline-none">
                                <SearchIcon class="h-6 w-6" aria-hidden="true" />
                            </button> -->

                            <!-- Profile dropdown -->
                            <user-navigation-dropdown
                                :user="$page.props.user"
                            ></user-navigation-dropdown>
                            <!-- Teams Dropdown, visible lg -->
                            <!--                            <jet-dropdown align="right" width="60" v-if="$page.props.jetstream.hasTeamFeatures"-->
                            <!--                                          class="hidden lg:visible">-->
                            <!--                                <template #trigger>-->
                            <!--                                    <span class="inline-flex rounded-md">-->
                            <!--                                        <button type="button"-->
                            <!--                                                class=" inline-flex items-center px-3 py-2 border border-transparent text-sm eading-4 font-medium rounded-md text-gray-500 bg-white hover:bg-gray-50 hover:text-gray-700 focus:outline-none focus:bg-gray-50 active:bg-gray-50 transition">-->
                            <!--                                            {{ $page.props.user.current_team.name }}-->

                            <!--                                            <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"-->
                            <!--                                                 viewBox="0 0 20 20" fill="currentColor">-->
                            <!--                                                <path fill-rule="evenodd"-->
                            <!--                                                      d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"-->
                            <!--                                                      clip-rule="evenodd" />-->
                            <!--                                            </svg>-->
                            <!--                                        </button>-->
                            <!--                                    </span>-->
                            <!--                                </template>-->

                            <!--                                <template #content>-->
                            <!--                                    <div class="w-60">-->
                            <!--                                        &lt;!&ndash; Team Management &ndash;&gt;-->
                            <!--                                        <template v-if="$page.props.jetstream.hasTeamFeatures">-->
                            <!--                                            <div class="block px-4 py-2 text-xs text-gray-400">-->
                            <!--                                                Manage Team-->
                            <!--                                            </div>-->

                            <!--                                            &lt;!&ndash; Team Settings &ndash;&gt;-->
                            <!--                                            <jet-dropdown-link-->
                            <!--                                                :href="route('teams.show',$page.props.user.current_team)">-->
                            <!--                                                Team Settings-->
                            <!--                                            </jet-dropdown-link>-->

                            <!--                                            <jet-dropdown-link :href="route('teams.create')"-->
                            <!--                                                               v-if=" $page.props.jetstream.canCreateTeams">-->
                            <!--                                                Create New Team-->
                            <!--                                            </jet-dropdown-link>-->

                            <!--                                            <div class="border-t border-gray-100"></div>-->

                            <!--                                            &lt;!&ndash; Team Switcher &ndash;&gt;-->
                            <!--                                            <div class="block px-4 py-2 text-xs text-gray-400">-->
                            <!--                                                Switch Teams-->
                            <!--                                            </div>-->

                            <!--                                            <template v-for="team in $page.props.user.all_teams" :key="team.id">-->
                            <!--                                                <form @submit.prevent="switchToTeam(team)">-->
                            <!--                                                    <jet-dropdown-link as="button">-->
                            <!--                                                        <div class="flex items-center">-->
                            <!--                                                            <svg v-if="team.id == $page.props.user.current_team_id"-->
                            <!--                                                                 class="mr-2 h-5 w-5 text-green-400" fill="none"-->
                            <!--                                                                 stroke-linecap="round" stroke-linejoin="round"-->
                            <!--                                                                 stroke-width="2" stroke="currentColor"-->
                            <!--                                                                 viewBox="0 0 24 24">-->
                            <!--                                                                <path-->
                            <!--                                                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>-->
                            <!--                                                            </svg>-->
                            <!--                                                            <div>{{ team.name }}</div>-->
                            <!--                                                        </div>-->
                            <!--                                                    </jet-dropdown-link>-->
                            <!--                                                </form>-->
                            <!--                                            </template>-->
                            <!--                                        </template>-->
                            <!--                                    </div>-->
                            <!--                                </template>-->
                            <!--                            </jet-dropdown>-->
                        </div>
                    </div>
                </div>
            </header>

            <!-- Page Content -->
            <main class="py-8 sm:py-10 overflow-y-scroll">
                <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                    <slot></slot>
                    <footer class="max-w-7xl mx-auto pt-10 lg:py-12">
                        <div
                            class="flex justify-between border-t border-slate-200 text-slate-500 pt-3 text-sm"
                        >
                            <div></div>
                            <div class="flex align-center">
                                <div v-if="$page.props.feedback_email">
                                    <a
                                        :href="`mailto:${$page.props.feedback_email}?subject=IMMIVO%20Feedback`"
                                        class="hover:text-minplan-blue group"
                                    >
                                        <ChatAlt2Icon
                                            class="h-5 ml-4 w-5 inline-block mr-2 group-hover:text-minplan-darkgreybeige"
                                        />
                                        <span>{{ $t('dialogs.sendFeedback') }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            </main>
        </div>

        <ComponentModal />
    </div>
</template>

<script>
import { defineComponent } from "vue";
import JetDropdown from "@/Jetstream/Dropdown.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import Toast from "@/Shared/Components/Toast";
import { SearchIcon, ChatAlt2Icon } from "@heroicons/vue/outline";
import UserNavigationDropdown from "@/Shared/Components/UserNavigationDropdown";
import ComponentModal from "@/Shared/Components/ComponentModal";
import io from "socket.io-client";
import {
    buildChatNotificationEventKey,
    fetchChatSocketContext,
    getChatNotificationTargets,
    getChatSocketUrl,
    isRelevantChatNotification,
    joinChatNotificationRooms,
    resolveChatNotificationPayload,
} from "@/Shared/Utils/chatNotifications";

export default defineComponent({
    props: {
        title: String,
    },
    components: {
        Head,
        JetDropdown,
        JetDropdownLink,
        Link,
        Toast,
        SearchIcon,
        ChatAlt2Icon,
        ComponentModal,
        UserNavigationDropdown,
    },

    data() {
        return {
            showingNavigationDropdown: false,
            globalSocket: null,
            unreadRefreshTimer: null,
            recentChatNotificationEvents: {},
            mutedThreadIds: [],
            removeSuccessEventListener: null,
            socketAuthRefreshInProgress: false,
            socketInitPromise: null,
        };
    },
    mounted() {
        this.initGlobalSocket();
        this.removeSuccessEventListener = Inertia.on("success", () => {
            this.refreshGlobalSocket();
        });
    },
    beforeUnmount() {
        if (this.unreadRefreshTimer) {
            clearTimeout(this.unreadRefreshTimer);
            this.unreadRefreshTimer = null;
        }
        if (this.removeSuccessEventListener) {
            this.removeSuccessEventListener();
            this.removeSuccessEventListener = null;
        }
        if (this.globalSocket) {
            this.globalSocket.disconnect();
            this.globalSocket = null;
        }
    },
    watch: {
        "$page.props.chatNotifications": {
            deep: true,
            handler() {
                this.refreshGlobalSocket();
            },
        },
    },

    methods: {
        switchToTeam(team) {
            this.$inertia.put(
                this.route("current-team.update"),
                {
                    team_id: team.id,
                },
                {
                    preserveState: false,
                }
            );
        },
        scheduleUnreadRefresh() {
            const only = [];

            if (this.$page.props.projects?.data) {
                only.push("projects");
            }
            if (Array.isArray(this.$page.props.apartments)) {
                only.push("apartments");
            }
            if (!only.length) return;

            if (this.unreadRefreshTimer) {
                clearTimeout(this.unreadRefreshTimer);
            }

            // this.unreadRefreshTimer = setTimeout(() => {
            //     this.unreadRefreshTimer = null;
            //     this.$inertia.reload({
            //         only,
            //         preserveScroll: true,
            //         preserveState: true,
            //     });
            // }, 150);
        },
        shouldHandleChatNotificationEvent(evt) {
            const now = Date.now();
            const ttl = 3000;
            const key = buildChatNotificationEventKey(evt);

            Object.keys(this.recentChatNotificationEvents).forEach((existingKey) => {
                if ((now - this.recentChatNotificationEvents[existingKey]) > ttl) {
                    delete this.recentChatNotificationEvents[existingKey];
                }
            });

            if (this.recentChatNotificationEvents[key]) {
                return false;
            }

            this.recentChatNotificationEvents[key] = now;
            return true;
        },
        async resolveBuyerApartmentThread(apartment, threadId) {
            if (!apartment?.uuid || !apartment?.buyer_id) {
                return false;
            }

            if (Number(apartment.chat_thread_id) === Number(threadId)) {
                return true;
            }

            try {
                const res = await window.axios.get(
                    `/c/apartments/${apartment.uuid}/buyers/${apartment.buyer_id}/chat/thread`
                );
                const resolvedThreadId = Number(res?.data?.thread?.id);
                if (resolvedThreadId) {
                    apartment.chat_thread_id = resolvedThreadId;
                }

                return resolvedThreadId === Number(threadId);
            } catch (_error) {
                return false;
            }
        },
        refreshGlobalSocketRooms() {
            if (!this.globalSocket || !this.globalSocket.connected) return;

            this.globalSocket.emit("user.join", { user_id: this.$page.props.user.id });

            const role = (this.$page.props.user.currentAgencyRole || "").toLowerCase();
            const isOwner = role === "owner";
            const isManager = role === "manager";

            const projects = Array.isArray(this.$page.props.projects?.data)
                ? this.$page.props.projects.data
                : [];
            const apartments = Array.isArray(this.$page.props.apartments)
                ? this.$page.props.apartments
                : [];

            const projectTargets = (isManager || isOwner)
                ? projects.filter((project) => project?.has_assigned_apartment === true)
                : projects;

            const apartmentTargets = (isManager || isOwner)
                ? apartments.filter((apartment) => {
                      if (apartment?.is_assigned_to_me === true) return true;
                      if (apartment?.apartment?.is_assigned_to_me === true) return true;
                      return false;
                  })
                : apartments;

            joinChatNotificationRooms(this.globalSocket, this.$page.props, {
                projects: projectTargets,
                apartments: apartmentTargets,
            });
        },
        async refreshSocketAuth() {
            if (!this.globalSocket || this.socketAuthRefreshInProgress) return;

            this.socketAuthRefreshInProgress = true;

            try {
                const { token, mutedThreadIds } = await fetchChatSocketContext(this.$page.props);
                if (!token) return;

                this.mutedThreadIds = mutedThreadIds;
                this.globalSocket.auth = { token };

                if (!this.globalSocket.connected) {
                    this.globalSocket.connect();
                }
            } catch (error) {
                console.error("Global socket auth refresh failed", error);
            } finally {
                this.socketAuthRefreshInProgress = false;
            }
        },
        async refreshGlobalSocket() {
            const chatTargets = getChatNotificationTargets(this.$page.props);
            if (!chatTargets.enabled) return;

            if (this.globalSocket) {
                if (this.globalSocket.connected) {
                    this.refreshGlobalSocketRooms();
                    return;
                }

                if (!this.globalSocket.active) {
                    await this.refreshSocketAuth();
                    return;
                }

                this.globalSocket.connect();
                return;
            }

            await this.initGlobalSocket();
        },
        async initGlobalSocket(forceReconnect = false) {
            if (this.socketInitPromise && !forceReconnect) {
                return this.socketInitPromise;
            }

            if (forceReconnect && this.globalSocket) {
                this.globalSocket.disconnect();
                this.globalSocket = null;
            }

            this.socketInitPromise = (async () => {
            try {
                const chatTargets = getChatNotificationTargets(this.$page.props);
                if (!chatTargets.enabled) return;

                const { token, mutedThreadIds } = await fetchChatSocketContext(this.$page.props);
                const socketUrl = getChatSocketUrl(this.$page.props);

                this.mutedThreadIds = mutedThreadIds;

                this.globalSocket = io(socketUrl, {
                    transports: ["websocket"],
                    auth: { token },
                    reconnection: true,
                    reconnectionAttempts: Infinity,
                    reconnectionDelay: 1000,
                });

                this.globalSocket.on("connect", () => {
                    this.refreshGlobalSocketRooms();
                });

                this.globalSocket.on("connect_error", () => {
                    this.refreshSocketAuth();
                });

                this.globalSocket.on("message.created", async (evt) => {
                    if (Number(evt.sender_id) === Number(this.$page.props.user.id)) return;
                    const userType = (this.$page.props.user?.type || "").toLowerCase();
                    if (userType === "advisor" && evt.sender_kind === "advisor") return;
                    if (!isRelevantChatNotification(this.$page.props, evt)) return;

                    const threadId = Number(evt.thread_id || evt.threadId);
                    const apartmentId = Number(evt.apartment_id || evt.apartmentId);
                    const explicitBuyerId = Number(evt.buyer_id || evt.buyerId);

                    const notificationTargets = getChatNotificationTargets(this.$page.props);
                    const apartments = Array.isArray(this.$page.props.apartments) && this.$page.props.apartments.length
                        ? this.$page.props.apartments
                        : notificationTargets.apartments;
                    const buyers = Array.isArray(this.$page.props.buyers) ? this.$page.props.buyers : [];
                    let ownedApartment = apartments.find((apartment) => Number(apartment.id) === apartmentId) || null;

                    if (userType === "buyer" && threadId) {
                        if (explicitBuyerId) {
                            const matchesBuyer = apartments.some((apartment) => Number(apartment.buyer_id) === explicitBuyerId);
                            const isOwnBuyerEvent =
                                matchesBuyer ||
                                buyers.some((buyer) => Number(buyer.id) === explicitBuyerId);

                            if (!isOwnBuyerEvent) {
                                return;
                            }

                            if (ownedApartment && Number(ownedApartment.buyer_id) === explicitBuyerId && !ownedApartment.chat_thread_id) {
                                ownedApartment.chat_thread_id = threadId;
                            }
                        } else if (ownedApartment) {
                            const ownsThread = await this.resolveBuyerApartmentThread(ownedApartment, threadId);
                            if (!ownsThread) {
                                return;
                            }
                        } else {
                            return;
                        }
                    }

                    if (!this.shouldHandleChatNotificationEvent(evt)) return;

                    const notification = await resolveChatNotificationPayload(this.$page.props, evt, this.route);

                    // Update projects list
                    if (this.$page.props.projects?.data) {
                        const project = this.$page.props.projects.data.find(p => Number(p.id) === Number(evt.project_id));
                        if (project) {
                             project.unread_count = (project.unread_count || 0) + 1;
                        }
                    }

                    // Update apartments list (used on client dash)
                    if (apartments.length) {
                        const apt = ownedApartment || apartments.find(a => Number(a.id) === apartmentId);
                        if (apt) {
                            if (!apt.chat_thread_id) {
                                apt.chat_thread_id = threadId;
                            }

                            // Isolation: if apt.chat_thread_id is specified (for buyers), only notify if IDs match
                            if (!apt.chat_thread_id || Number(apt.chat_thread_id) === threadId) {
                                apt.unread_count = (apt.unread_count || 0) + 1;
                            }
                        }
                    }

                    const targetApartment = notificationTargets.apartments.find(a => Number(a.id) === Number(evt.apartment_id));
                    const isAssignedAdvisor = userType !== "advisor" || Number(targetApartment?.assigned_advisor_user_id) === Number(this.$page.props.user.id);
                    if (!isAssignedAdvisor) return;

                    if (notification) {
                        this.$notify({
                            group: "success",
                            title: notification.title,
                            text: notification.text,
                            url: notification.url,
                        }, 4000);

                        const threadId = Number(notification.threadId || evt.thread_id || evt.threadId);
                        const mutedThreads = JSON.parse(localStorage.getItem('chat_muted_threads') || '{}');
                        const isSpecificMuted = this.mutedThreadIds.includes(threadId) || !!mutedThreads[threadId];

                        if (!isSpecificMuted) {
                            const audio = new Audio("https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3");
                            audio.play().catch(e => console.log('Audio play failed:', e));
                        }
                        
                        this.scheduleUnreadRefresh();
                    }
                });

                this.globalSocket.on("thread.read_changed", (evt) => {
                    if (Number(evt.user_id) !== Number(this.$page.props.user.id)) return;

                    this.scheduleUnreadRefresh();
                });

            } catch (e) {
                console.error("Global socket init failed", e);
            }
            })().finally(() => {
                this.socketInitPromise = null;
            });

            return this.socketInitPromise;
        },
    },
});
</script>
